export default __webpack_public_path__ + "fonts/9b954fe7edeaf5c09b8499e5d541e5d7.svg";